module.exports = __webpack_public_path__ + "static/zem111lp-160283b80812ee09c03af6dbd386fb66.png";